import * as types from './mutation-types'

export default {
    [types.AUTH_SUCCESS] (state, token) {
        state.token = token
    },

    [types.AUTH_LOGOUT] (state) {
        state.token = null
    }
}
